import { render, staticRenderFns } from "./assignad.vue?vue&type=template&id=65e3e137&"
import script from "./assignad.vue?vue&type=script&lang=js&"
export * from "./assignad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports